<template>
  <div
    v-if="customWidget"
    class="widget white_box"
  >
    <div class="widget_header">
      <h3 class="heading">
        {{ customWidget.heading }}
      </h3>
      <div
        v-if="editing"
        class="edit_buttons"
      >
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove()"
        >
          Delete
        </button>
      </div>
    </div>
    <div
      class="content"
      v-html="customWidget.code"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import {mapState} from 'vuex';

export default {
  props: {
    widget: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('dashboard', ['customWidgets']),
    customWidget() {
      return _.find(this.customWidgets, {id: this.widget.custom_widget_id});
    },
  }
}
</script>

<style scoped>
.content {
  height: 326px;
  overflow: hidden;
}
</style>
